export const CommonTestIds = {
  popup: {
    title: 'popup-title',
    description: 'popup-description',
    actionLeft: 'popup-action-left',
    actionRight: 'popup-action-right',
  },
  adsSection: {
    section: 'ads-section',
    title: 'ads-section-title',
    showAll: 'ads-section-show-all-link',
  },
  adCards: {
    cardsBox: 'ad-cards-box',
    card: 'ad-card',
  },
  errorPage: {
    notFoundImage: 'error-page-not-found-image',
    unexpectedErrorImage: 'error-page-unexpected-error-image',
    title: 'error-page-title',
    subtitle: 'error-page-subtitle',
  },
  input: {
    input: 'input',
  },
  header: {
    box: 'header-box',
    backButton: 'header-back-button',
    logoLink: 'header-logo-link',
    newAdButton: 'header-add-new-ad-button',
  },
  desktopHeader: {
    rightAction: 'desktop-header-right-action',
    bookmarksLink: 'desktop-header-bookmarks-link',
    messagesLink: 'desktop-header-messages-link',
    newAdButton: 'desktop-header-new-ad-button',
  },
  desktopHeaderCatalogue: {
    button: 'desktop-header-catalogue-btn',
    overlay: 'desktop-header-catalogue-overlay',
    content: 'desktop-header-catalogue-content',
  },
  navMenu: {
    button: 'nav-menu-button',
    overlay: 'nav-menu-overlay',
    drawer: 'nav-menu-drawer',
    close: 'nav-menu-close',
    phone: 'nav-menu-phone',
    email: 'nav-menu-email',
    facebook: 'nav-menu-facebook',
    instagram: 'nav-menu-instagram',
  },
  adImages: {
    fileUpload: 'ad-images-file-upload',
    item: 'ad-images-item',
    addButton: 'ad-images-add-button',
    presetPhotoPickerGrid: 'ad-images-preset-photo-picker-grid',
    presetPhotoItem: 'ad-images-preset-photo-item',
    presetPhotoPickerApplyButton: 'ad-images-preset-photo-picker-apply-button',
  },
  auth: {
    iframe: {
      drawer: 'auth-iframe-drawer',
      popup: 'auth-iframe-popup',
    },
  },
  searchPanel: {
    box: 'search-panel-box',
    input: 'search-panel-input',
    overlay: 'search-panel-overlay',
  },
  searchSuggestions: {
    content: 'search-suggestions-content',
    item: (i: number) => `search-suggestion-${i}`,
    category: 'search-suggestion-category',
    text: 'search-suggestion-text',
  },
  profileMenu: {
    loginButton: 'profile-menu-login-btn',
    button: 'profile-menu-btn',
    content: 'profile-menu-content',
  },
  addToPremium: {
    card: 'add-to-premium-card',
    modal: 'add-to-premium-modal',
  },
  warningModal: {
    title: 'warning-modal-title',
    description: 'warning-modal-description',
    actions: 'warning-modal-actions',
    actionButton: 'warning-modal-action-button',
  },
};
